export function getAccessToken() {
  return localStorage.getItem('accessToken')
    || localStorage.getItem('token')
    || localStorage.getItem('jwt')
    || '';
}

export function getApiBaseUrl() {
  return (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
}

export function isAdminFlag(value) {
  if (value === true || value === 1) return true;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes';
  }

  return false;
}

export function getStoredUser() {
  try {
    const rawUser = localStorage.getItem('user');
    return rawUser ? JSON.parse(rawUser) : null;
  } catch (error) {
    return null;
  }
}

export function hasAdminAccess(user, payload) {
  return Boolean(
    isAdminFlag(user?.is_admin)
      || isAdminFlag(payload?.is_admin)
      || user?.admin_role
      || payload?.admin_role
  );
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;

  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

export function isTokenExpired(payload) {
  if (!payload || typeof payload.exp !== 'number') return true;
  return payload.exp * 1000 <= Date.now();
}

export function getAuthState() {
  const token = getAccessToken();
  const payload = decodeJwtPayload(token);
  const storedUser = getStoredUser();
  const authenticated = Boolean(token && payload && !isTokenExpired(payload) && payload.id && payload.email);

  return {
    token,
    payload,
    authenticated,
    isAdmin: Boolean(authenticated && hasAdminAccess(storedUser, payload)),
    adminRole: authenticated && payload ? (payload.admin_role ?? null) : null
  };
}

export function clearStoredAuth() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('token');
  localStorage.removeItem('jwt');
  localStorage.removeItem('user');
}

export async function verifyAdminAccess(token = getAccessToken()) {
  if (!token) {
    return { ok: false, status: 401 };
  }

  try {
    const response = await fetch(`${getApiBaseUrl()}/auth/admin/verify`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      return { ok: false, status: response.status };
    }

    const data = await response.json().catch(() => ({}));
    return { ok: true, status: response.status, data };
  } catch (error) {
    return { ok: false, status: 0, error };
  }
}

export function resolveAdminAccess(authState, verificationResult) {
  if (!authState?.authenticated) {
    return 'unauthenticated';
  }

  if (verificationResult?.ok) {
    return 'authorized';
  }

  if (verificationResult?.status === 401) {
    return 'unauthenticated';
  }

  if ((verificationResult?.status === 0 || verificationResult?.status === 404 || verificationResult?.status >= 500) && authState?.isAdmin) {
    return 'authorized';
  }

  return 'forbidden';
}